<template>
  <v-img width='200px' :src="pageData.baseURL + 'template/accueil/images/beta.png'" aspect-ratio="1.7" contain style="position: fixed; top: 0; left: 0; z-index: 99999; pointer-events: none; opacity: .7"></v-img>
</template>

<script>
export default {
  name: "acc-dev",
    computed: {
        pageData() {
            return this.$store.getters.getPageData;
        }
    },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// template/accueil/components/DevIndicatore.vue